import React from "react";
import { Row, Col } from "react-bootstrap";
import OrganizerPillSelect from "../components/OrganizerPillSelect";
import { HORAS_ANTES_RECORDATORIO, usePuedeCrearPlantillas } from "./recordatorios";
import CanalWhatsapp, { CanalEmail, CanalPush } from "./CanalWhatsapp";

/* Reminder settings block of the three verticals' policy forms (Beauty, courts, tables). It sits in a full-width
   column of the form's Row. `onChange(field, value)` is called with `recordatoriosActivos` or
   `horasAntesRecordatorio`, the form fields built by recordatoriosDeVenue.
   The forms pass `whatsapp` (form value) and `onWhatsappChange`; without them the block is the plain email one.
   `onAntesDeIrAChat` runs when the Zoco Chat link is clicked, so the form can keep its unsaved edits (borradorPoliticas).
   Creating templates is for the owner and Chat admins only (usePuedeCrearPlantillas). `local` is the venue's name, for the message preview. */

const OPCIONES = HORAS_ANTES_RECORDATORIO.map((value) => ({ value, label: `${value} horas antes` }));

const RecordatoriosAjustes = ({ activos, horasAntes, onChange, whatsapp, onWhatsappChange, push, onPushChange, sustantivo = "reserva", local, errorWhatsapp, onAntesDeIrAChat, volver }) => {
  const puedeCrear = usePuedeCrearPlantillas();
  return (
  <Row className="g-4">
    <Col md={6}>
      <div className="zr-field">
        <span className="zr-field__label">Recordatorios</span>
        <input
          type="checkbox"
          className="zr-switch"
          aria-label="Recordatorios"
          checked={Boolean(activos)}
          onChange={() => onChange("recordatoriosActivos", !activos)}
        />
        <small style={{ color: "#6b7280", fontSize: 12 }}>
          {whatsapp && onWhatsappChange ? "Se envían por email y, si lo activás abajo, por WhatsApp" : "Se envían por email"}
        </small>
      </div>
    </Col>
    {activos && (
      <Col md={6}>
        <div className="zr-field">
          <span id="recordatorios-horas-label" className="zr-field__label">Cuántas horas antes</span>
          <OrganizerPillSelect
            id="recordatorios-horas"
            labelledBy="recordatorios-horas-label"
            value={horasAntes}
            onChange={(val) => onChange("horasAntesRecordatorio", Number(val))}
            options={OPCIONES}
          />
        </div>
      </Col>
    )}
    {activos && ((whatsapp && onWhatsappChange) || (push && onPushChange)) && (
      <Col md={12}>
        <div className="zr-field">
          <span id="canales-label" className="zr-field__label">Canales</span>
          <div className="rwa-canales" role="group" aria-labelledby="canales-label">
            <CanalEmail />
            {whatsapp && onWhatsappChange && (
              <CanalWhatsapp
                whatsapp={whatsapp}
                onChange={onWhatsappChange}
                local={local}
                error={errorWhatsapp}
                puedeCrear={puedeCrear}
                onAntesDeIrAChat={onAntesDeIrAChat}
                volver={volver}
              />
            )}
            {push && onPushChange && <CanalPush push={push} onChange={onPushChange} etiqueta="Recordatorio por notificación en la app" tipo="reminder" sustantivo={sustantivo} />}
          </div>
        </div>
      </Col>
    )}
  </Row>
  );
};

export default RecordatoriosAjustes;
